// Copyright (c) Ping. All rights reserved.
//
// Web variant of the media-viewer icons (Figma 4036:28876 / 4036:29106).
// react-native-svg has no runtime under react-native-web (the project
// aliases lucide-react-native → lucide-react and never installs the
// native SVG package on web), so we encode the parametrised SVG as a
// `data:image/svg+xml;base64,…` URI and feed it to `<Image>`. macOS uses
// the `.macos.tsx` sibling and renders the same XML via `SvgXml`.
// Mirrors `icons/NavIcon.tsx`.

import { Image } from 'react-native';
import { getMediaPreviewIconSvg, type MediaPreviewIconName } from './mediaPreviewIconSvgs';

export interface MediaPreviewIconProps {
  readonly name: MediaPreviewIconName;
  readonly size?: number;
  readonly color: string;
  readonly accessibilityLabel?: string;
}

export function MediaPreviewIcon({
  name,
  size = 24,
  color,
  accessibilityLabel,
}: MediaPreviewIconProps): JSX.Element {
  const svg = getMediaPreviewIconSvg(name, color);
  // `btoa` is available in browsers; the SVG strings are pure ASCII so
  // no unicode workaround is needed.
  const uri =
    typeof btoa !== 'undefined'
      ? `data:image/svg+xml;base64,${btoa(svg)}`
      : `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
  return (
    <Image
      source={{ uri }}
      accessibilityIgnoresInvertColors
      accessibilityLabel={accessibilityLabel ?? name}
      style={{ width: size, height: size }}
      resizeMode="contain"
    />
  );
}
